"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationsApi = void 0;
const handlers_1 = require("../handlers");
exports.notificationsApi = (http, prefix = '/notifications') => ({
    getById(id) {
        return http.get(`${prefix}/${id}`);
    },
    getAllForRecipient(ownerId, channels = []) {
        return (channels && channels.length ?
            http.post(`${prefix}/recipient/${ownerId}/channels`, channels) :
            http.get(`${prefix}/recipient/${ownerId}`)).catch(handlers_1._404([]));
    },
    dismiss(id) {
        return http.put(`${prefix}/${id}/dismiss`);
    }
});
//# sourceMappingURL=index.js.map